import React from "react";
import { IKImage } from "imagekitio-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Rate from "./Rate";
import useWindowSize from "../../hooks/useWindowSize";

const Review = ({ reviewData, showMore, handleShowMore, index }) => {
  const { width } = useWindowSize();
  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  return (
    <div className="rounded- mr-2 flex flex-col rounded-xl bg-[#2D4F71] p-4">
      <div className="mb-5 flex items-center">
        {reviewData?.user_image_url ? (
          <div className="relative">
            <img
              src={reviewData?.user_image_url}
              className="h-12 w-12 rounded-full ring ring-[#F59E0B] "
              alt="review image"
            />
            <img
              src="https://img.learntube.ai/public-assets/PRICING/img28.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662191682870"
              alt="crown icon"
              className="absolute -right-1 -bottom-1"
            />
          </div>
        ) : (
          <FontAwesomeIcon
            icon={faUserCircle}
            className={"h-12 w-14 rounded-full"}
          />
        )}
        <div className="ml-3 flex flex-col text-left text-white">
          <h1 className="text-sm font-semibold">{reviewData?.name}</h1>
          <h4 className="text-xs opacity-50">
            Member since {months[new Date(reviewData?.created_at).getMonth()]}{" "}
            {new Date(reviewData?.created_at).getFullYear()}
          </h4>
        </div>
      </div>
      <div className="-mt-2 text-left">
        <Rate
          rating={5}
          color={{
            filled: "#FFD700",
            unfilled: "#808080",
          }}
          count={5}
          size={"lg"}
          isReadOnly={true}
        />
      </div>
      <div
        className={`mr-1 mt-3 text-left text-sm font-medium ${
          showMore ? "" : "line-clamp-4"
        } text-white`}
      >
        {reviewData?.testimonial}
      </div>
      <p
        className="cursor-pointer font-medium text-[#40DA90] underline"
        onClick={() => handleShowMore(index)}
      >
        {showMore ? "Show Less" : "Show More"}
      </p>
    </div>
  );
};

export default Review;
